<template>
  <div class="flex" v-loading="loading">
    <div class="left">
      <el-tree
        default-expand-all
        :data="treeData"
        show-checkbox
        node-key="id"
        ref="tree"
        @check="selectChange"
        :default-expanded-keys="[2, 3]"
        :default-checked-keys="resourceCheckedKey"
        :props="defaultProps">
      </el-tree>
    </div>
    <div class="right">
      <Table ref="table"
             :perDatas="perDatas"
             :outPerDatas="outPerDatas"
             :orgDatas="orgDatas"
             :state="state"
             :cusId="cusId"
             v-on:personDatas="personClick"></Table>
    </div>
  </div>

</template>

<script>
  import Table from "@/views/wage/set/payGroupSetting/table.vue";
  import {queryOrgTreeSelect} from "@/api/wage/payGroup";
  import Vue from 'vue'

  export default {
    name: "selectPerson",
    props:{
      perDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      outPerDatas: {
          type: Array,
          default: () => (
              []
          )
      },
      orgDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      cusId:{
        type:String,
        default:"",
      },
      title: {
        type: String,
        default: () => (
          ''
        )
      },
      state: {
        type: String,
        default: '',
      },

    },
    created(){
      console.log("000000000this.perDatas-----",this.perDatas);
      console.log("6000000000this.outPerDatas------",this.outPerDatas);
      console.log("6000000000this.cusId------",this.cusId);
      this._queryOrgTreeSelect();
    },
    components:{Table},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'orgName'
        },
        expandedKeys:[],
        orgMaps:{},
        treeData:[],
        orgIds:[],
        loading:false,
      };
    },
    methods:{
      _queryOrgTreeSelect(){
        console.log("this.cusId------",this.cusId);
        queryOrgTreeSelect(this.cusId).then((res) => {
           this.treeData = res.data;
           this.expandedKeys.push(res.data[0].id);
           console.log("机构数组------",this.treeData);
            const arr = [];
            for(var i= 0;i < res.data.length;i++){
                arr.push(res.data[i].id);
            }
            console.log("const arr =",arr);
            this.$refs.tree.setCheckedKeys(arr);
            this.$forceUpdate();
        });
      },
      selectChange(){
        this.orgIds = this.$refs.tree.getCheckedKeys();
        console.log("选择机构ids------",this.orgIds);
        this.$refs.table._getListpage(this.orgIds);
      },
      personClick(e){
        this.$emit('personDatas',e);
      }

    }
  };
</script>

<style scoped>
  .flex{
    display: flex;
  }
  .flex>div{
    height: 600px;
  }
  .flex>div:nth-of-type(1){
    width: 250px;
    border-right: 1px solid #ccc;
    padding-right: 20px;
    margin-right:20px;
    overflow: auto;
  }
  .flex>div:nth-of-type(2){
    width: calc(100% - 255px);
  }
</style>
